import { captureException } from "@lululemon/mwa-utils";

export const bttStart = (key, pageName) => {
  if (typeof window === "undefined" || !window.bttUT || !pageName) {
    return;
  }

  try {
    window.bttUT.start({
      pageName,
      key,
      txnName: window.bttUT.txnName,
    });
  } catch (e) {
    captureException(e, "error", { tags: { isThirdParty: true } });
  }
};

export const bttEnd = (key, pageName) => {
  if (typeof window === "undefined" || !window.bttUT) {
    return;
  }

  try {
    window.bttUT.end({
      pageName,
      key,
      txnName: window.bttUT.txnName,
    });
  } catch (e) {
    captureException(e, "error", { tags: { isThirdParty: true } });
  }
};

export const ADD_TO_BAG_BTT_PAGE_NAME = "addToBag-VT";
export const QUICK_VIEW_BTT_MODAL_NAME = "quickView";
export const CDP_BTT_PAGE_NAME = "cdp-VT";
export const CDP_LAZYLOAD_BTT_PAGE_NAME = "cdp-VT-LazyLoad";
export const ADD_TO_BAG_PRODUCT_RECOMMENDATIONS_BTT_PAGE_NAME =
  "preBag-addToBag-productRecommendations";
